import "../Services.css";
import DeskImage from "../../Assets/Images/desk-image.png";
import FAQSection from "./BookkeepingFAQ.js";

const App = () => {
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>Wave goodbye to disorganized books.</h1>
            <p className="hero-subtitle">Bookkeeping designed for start-ups and growing businesses.</p>
          </div>
          <div className="hero-media">
            <img src={DeskImage} alt="Desk Illustration" className="desk-image" />
          </div>
        </div>
      </div>
      <FAQSection />
    </section>
  );
};

export default App;
